import { render, staticRenderFns } from "./AddDocumentModal.vue?vue&type=template&id=3cd804f5&scoped=true&"
import script from "./AddDocumentModal.vue?vue&type=script&lang=js&"
export * from "./AddDocumentModal.vue?vue&type=script&lang=js&"
import style0 from "./AddDocumentModal.vue?vue&type=style&index=0&id=3cd804f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd804f5",
  null
  
)

export default component.exports